module.exports = __webpack_public_path__ + "fonts/sm-arrow-green.svg";